import React from "react";
import { Link } from "react-router-dom";
import { PawPrint, CalendarDays } from "lucide-react";
import Reveal from "./Reveal";

const AppointmentBanner = ({ className = "" }) => {
  return (
    <Reveal animation="zoomIn" className={`overflow-hidden rounded-[32px] bg-pawelle-primary ${className}`}>
      <div className="relative flex flex-col items-center gap-6 px-8 py-14 text-center md:flex-row md:justify-between md:text-left">
        <PawPrint className="pointer-events-none absolute -left-4 -top-4 h-28 w-28 text-white/10" />
        <PawPrint className="pointer-events-none absolute -bottom-6 right-10 h-24 w-24 text-white/10" />
        <div className="relative">
          <span className="inline-flex items-center gap-2 font-display text-[14px] font-semibold text-white/80">
            <PawPrint className="h-4 w-4" /> Book an Appointment
          </span>
          <h3 className="mt-3 max-w-2xl font-display text-[28px] font-bold text-white md:text-[36px]">
            Book Your Free Consultation Today
          </h3>
          <p className="mt-3 font-body text-[16px] text-white/85">
            Get personalized care advice from our veterinary experts—completely free.
          </p>
        </div>
        <Link
          to="/gb/en/appointment.html"
          className="relative inline-flex items-center gap-2 rounded-full bg-white px-8 py-4 font-display text-[16px] font-medium text-pawelle-primary transition-all duration-300 hover:-translate-y-0.5 hover:bg-pawelle-ink hover:text-white"
        >
          <CalendarDays className="h-5 w-5" />
          Book Now
        </Link>
      </div>
    </Reveal>
  );
};

export default AppointmentBanner;
